module.exports = __webpack_public_path__ + "static/media/xtreme-19.b2775e61.png";